import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { NotificationTypes } from 'src/app/app.enums';
import { AuthConfig, AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { GalleryConsignmentProduct } from 'src/app/Services/consignment.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { Location, SquareupPosService } from 'src/app/Services/squareup-pos.service.ts/squareup-pos.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'connect-squareup-pos-account',
    templateUrl: './connect-squareup-pos-account.component.html',
    inputs: ['isSentByEditProfile'],
    standalone: false
})
export class ConnectSquareupPosAccountComponent implements OnInit {
  public authConfig: AuthConfig = {};
  public posAccounts: Location[] = [];
  public SquarePOSLoggedInAt!: string;
  public SquarePOSTokkenExpireAt!: string;
  public isAuthenticated: boolean = false;
  public isStatusActive: boolean = false;
  public isConnectSquareupSuccessDialogVisible: boolean = false;
  public Products: GalleryConsignmentProduct[] = [];
  public SquareupSyncProducts: boolean = false;
  public isSentByEditProfile: boolean = false;
  constructor(
    private ngxSpinnerService: NgxSpinnerService,
    private squareupPosService: SquareupPosService,
    private notificationsService: NotificationsService,
    private authService: AuthService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private transloco: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.isAuthenticated = this.authService.isAuthenticated();
    this.authConfig = this.authService.getAuthConfig();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['code'] && params['state']) {
          this.onConnectWithPosAccountCallBack(params['code'], params['state']);
      }
    });
    console.log(this.isSentByEditProfile)
    if(this.isSentByEditProfile == false){
      this.fetchConnectedPosAccount();
    }

    this.SquareupSyncProducts = true
  }

  public onConnectSquareupPosAccount(): void {
    this.ngxSpinnerService.show();
    this.squareupPosService.connectWithPosAccount().subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        console.log('POS account connection successful:', response);
        if (response.Success) {
          window.location.href = response.ResponseData;
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Failed to connect to POS account:', error);
        this.notificationsService.showNotification(
          this.transloco.translate('connectSquareupPosAccount.connectionFailedTitle'),
          this.transloco.translate('connectSquareupPosAccount.errorConnectingPosAccount'),
          NotificationTypes.Error
        );
      }
    );
  }

  public onConnectWithPosAccountCallBack(code: string, state: string): void {
    this.ngxSpinnerService.show();
    this.squareupPosService.onConnectWithPosAccountCallBack(code, state).subscribe((SquarePosAccount: ResponseObject) => {
        console.log(SquarePosAccount);
        // Handle success
        if (SquarePosAccount.Success) {
            this.notificationsService.showNotification(this.transloco.translate('connectSquareupPosAccount.successTitle'),SquarePosAccount.ResponseMessage,NotificationTypes.Success);
            this.router.navigate([], {
              relativeTo: this.activatedRoute,
              queryParams: {},
              replaceUrl: true,
            });
            this.isConnectSquareupSuccessDialogVisible = true
            this.fetchConnectedPosAccount();
        }
        this.ngxSpinnerService.hide();
    },
    (error) => {console.error(error);this.ngxSpinnerService.hide();});
  }

  public closeSquareupCheckoutDialog(): void {
    this.isConnectSquareupSuccessDialogVisible = false;
  }

  public fetchConnectedPosAccount(): void {
    this.posAccounts = [];
    this.ngxSpinnerService.show();
    this.squareupPosService.getConnectedPosAccount().subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.responseObject.Success && response.location && response.location.length > 0) {
          this.posAccounts = response.location;
          this.SquarePOSLoggedInAt = response.SquarePOSLoggedInAt;
          this.SquarePOSTokkenExpireAt = response.SquarePOSTokkenExpireAt;
          this.isStatusActive = response.location[0].status === 'ACTIVE';
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Error fetching POS account details:', error);
        this.notificationsService.showNotification(
          this.transloco.translate('connectSquareupPosAccount.errorTitle'),
          this.transloco.translate('connectSquareupPosAccount.failedToFetchPosDetails'),
          NotificationTypes.Error
        );
      }
    );
  }

  public confirmDisconnectPosAccount(): void {
    this.confirmationService.confirm({
      message: this.transloco.translate('connectSquareupPosAccount.disconnectConfirm'),
      header: this.transloco.translate('connectSquareupPosAccount.confirmDisconnectionHeader'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.disconnectPosAccount();
      },
      reject: () => {
        console.log('POS account disconnection was cancelled.');
      }
    });
  }

  private disconnectPosAccount(): void {
    this.ngxSpinnerService.show();
    this.squareupPosService.onDisConnectWithPosAccount().subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.fetchConnectedPosAccount();
          this.notificationsService.showNotification(
            this.transloco.translate('connectSquareupPosAccount.successTitle'),
            this.transloco.translate('connectSquareupPosAccount.accountDisconnectedSuccess'),
            NotificationTypes.Success
          );
        } else {
          this.notificationsService.showNotification(
            this.transloco.translate('connectSquareupPosAccount.failedTitle'),
            response.ResponseMessage,
            NotificationTypes.Error
          );
        }
      },
      (error) => {
        this.ngxSpinnerService.hide();
        console.error('Failed to disconnect POS account:', error);
        this.notificationsService.showNotification(
          this.transloco.translate('connectSquareupPosAccount.failedTitle'),
          this.transloco.translate('connectSquareupPosAccount.errorDisconnectingPosAccount'),
          NotificationTypes.Error
        );
      }
    );
  }
}
